import { reviewBodySchema } from "@redotech/redo-model/review/review-body-schema";
import * as z from "zod/v4";

export const getReviewsByTeamId = {
  name: "getReviewsByTeamId" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(reviewBodySchema),
};
